import React  from "react";
import { connect } from "react-redux";
import CurrencyFormatter from "currency-formatter";
import "../../../Dashboard/dashboard.css";
import { useEffect } from "react";
import {
  generateForecastedDepreciation,
  updateForecastDepreciation
} from "../../../../store/modules/forecastDepreciation/actions";
import InputLabel from "@mui/material/InputLabel";
import { rowStyle } from "../../../Dashboard/customStyles";
import BVAInput from "../../../../components/BVAInput/BVAInput";
import FinancialHandler from "../../../../handlers/FinancialHandler";

const ForecastDepreciation = ({
  appState,
  forecastedDepreciation,
  dispatchGenerateForecastDepreciation,
  dispatchUpdateForecastDepreciation
}) => {
  // Mounted
  useEffect(() => {
    dispatchGenerateForecastDepreciation()
  }, [])

  // Methods
  const handleChange = (key, value) => {
    dispatchUpdateForecastDepreciation({
      [key]: key === "analystNote" ? value : CurrencyFormatter.unformat(value, { code: "USD" })
    })
  }

  const handleOnClickGPT = async () => {
    handleChange("analystNote", "Generating...");
    const payload =
      "Based on our forecasted revenue, we input the percentage of depreciation attributed to the capital expenditures. Businesses with assets that wear out faster will have a higher depreciation percentage and vice versa. This gives us our forecasted depreciation for the next year. These are the company's depreciation forecast data." +
      "\nRevenue Estimate: " + Number(forecastedDepreciation?.forecastedRevenue).toFixed(2) + "$" +
      "\nDepreciation Percentage of Revenue: " + Number(forecastedDepreciation?.depreciationPercentageRevenue).toFixed(2) + "%" +
      "\nDepreciation Amount: " + Number(forecastedDepreciation?.depreciationAmount).toFixed(2) + "$" +
      "\nGrowth Rate: " + Number(forecastedDepreciation?.growthRate * 100 - 100).toFixed(2) + "%" +
      "\nForecasted Depreciation: " + Number(forecastedDepreciation?.forecastedValue).toFixed(2) + "$" +
      "\nPlease analyze this company's forecasted depreciation situation."
    const note = await FinancialHandler.fetchGPTSimpleNoteGeneration(payload);
    handleChange("analystNote", note);
  }

  return (
    <>
      <h2 className="sectionHead">Forecasted Depreciation</h2>
        <div className="dashboard-content">
          <div className="data-title-container">
            <div></div>

            <div className="data-title">
              <h6>{appState.companyData.name}</h6>
              <p>Depreciation Forecast</p>
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>Revenue Estimate</InputLabel>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                width: "50%",
              }}
            >
              <BVAInput
                disabled
                size="small"
                id="depreciation-forecastedRevenue"
                startAdornment
                startAdornmentLabel="$"
                value={forecastedDepreciation?.forecastedRevenue}
              />
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>Depreciation % of Revenue</InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                size="small"
                id="depreciation-depreciationPercentageRevenue"
                startAdornment
                startAdornmentLabel="x"
                endAdornmentLabel="%"
                endAdornment
                textAlign="end"
                onChange={(value) => handleChange("depreciationPercentageRevenue", value)}
                value={forecastedDepreciation?.depreciationPercentageRevenue}
              />
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>Depreciation Amount</InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                disabled
                size="small"
                id="depreciation-depreciationAmount"
                startAdornment
                startAdornmentLabel="$"
                value={forecastedDepreciation?.depreciationAmount}
              />
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel>1 + Growth Rate</InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                disabled
                size="small"
                id="depreciation-growthRate"
                startAdornment
                startAdornmentLabel="x"
                value={forecastedDepreciation?.growthRate}
              />
            </div>
          </div>

          <div style={rowStyle.baseRow}>
            <div style={rowStyle.labelRow}>
              <InputLabel style={{ fontWeight: "bold" }}>
                Forecasted Depreciation
              </InputLabel>
            </div>
            <div style={rowStyle.fieldRow}>
              <BVAInput
                disabled
                size="small"
                id="depreciation-forecastedValue"
                startAdornment
                startAdornmentLabel="$"
                value={forecastedDepreciation?.forecastedValue}
              />
            </div>
          </div>

          <div className="data-bottom mt-10 mr-20 pr-20" style={{ width: "45em" }}>
            <h5 className="noteHead">Analyst Note&nbsp;&nbsp;&nbsp;<button onClick={() => handleOnClickGPT()}>🤖</button></h5>
            <textarea
              className="analystNote"
              rows={3}
              value={forecastedDepreciation?.analystNote}
              onChange={(e) => handleChange("analystNote", e.target.value)}
            />
          </div>
        </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    forecastDepreciation: state.forecastDepreciation,
    forecastedDepreciation: state.forecastDepreciation.forecastedDepreciation,
    taxes: state.taxes,
    appState: state.appState,
  };
};

const mapDispatchToProps = (dispatch) => ({
  dispatchGenerateForecastDepreciation(){
    dispatch(generateForecastedDepreciation())
  },

  dispatchUpdateForecastDepreciation({ depreciationPercentageRevenue, analystNote }) {
    dispatch(updateForecastDepreciation({ depreciationPercentageRevenue, analystNote }))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(ForecastDepreciation);
